function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#282828;}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 27.49,
  cy: 27.49,
  r: 24.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M27.49,0a27.48,27.48,0,1,0,.05,0ZM41.24,37.37l-3.88,3.87-9.87-9.87-9.87,9.87-3.87-3.87,9.87-9.87-9.87-9.87,3.87-3.88,9.87,9.87,9.87-9.87,3.88,3.88L31.37,27.5Z"
});

const SvgDelete = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 54.99 54.99",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.c9816317.svg";
export { ForwardRef as ReactComponent };